var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            inline: "",
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.superior"),
                        prop: "upIdList"
                      }
                    },
                    [
                      _c("el-cascader", {
                        staticClass: "form-item-width",
                        attrs: {
                          clearable: "",
                          options: _vm.options,
                          props: _vm.propstree,
                          disabled: _vm.keyValue > 0,
                          placeholder: "请先选择上级机构"
                        },
                        on: {
                          change: function($event) {
                            return _vm.getBuildingId(_vm.childData.upIdList)
                          }
                        },
                        model: {
                          value: _vm.childData.upIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "upIdList", $$v)
                          },
                          expression: "childData.upIdList"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.buildingFloor"),
                        prop: "floorNumber"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择楼层",
                            disabled: _vm.isDisabled
                          },
                          on: { focus: _vm.checkArea },
                          model: {
                            value: _vm.childData.floorNumber,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "floorNumber", $$v)
                            },
                            expression: "childData.floorNumber"
                          }
                        },
                        _vm._l(_vm.floorOption, function(item) {
                          return _c("el-option", {
                            key: item.floorNumber,
                            attrs: {
                              label: item.floorName,
                              value: item.floorNumber
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序" } },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-width",
                        attrs: {
                          min: 0,
                          max: 99999,
                          clearablet: "",
                          type: "text"
                        },
                        model: {
                          value: _vm.childData.houseOrder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "houseOrder", $$v)
                          },
                          expression: "childData.houseOrder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.roomCode"),
                        prop: "houseCode"
                      }
                    },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", type: "text" },
                        model: {
                          value: _vm.childData.houseCode,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "houseCode", $$v)
                          },
                          expression: "childData.houseCode"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "使用性质" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择使用性质"
                          },
                          model: {
                            value: _vm.childData.houseType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "houseType", $$v)
                            },
                            expression: "childData.houseType"
                          }
                        },
                        _vm._l(_vm.typeOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              label: item.dicName,
                              value: parseInt(item.dicValue)
                            },
                            on: { change: _vm.changeTypeValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.buildArea"),
                        prop: "houseArea"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", min: 1, max: 99999 },
                        model: {
                          value: _vm.childData.houseArea,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "houseArea", $$v)
                          },
                          expression: "childData.houseArea"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.useArea"),
                        prop: "houseUseArea"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", min: 1, max: 99999 },
                        model: {
                          value: _vm.childData.houseUseArea,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "houseUseArea", $$v)
                          },
                          expression: "childData.houseUseArea"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.roomState"),
                        prop: "houseStatus"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择房间状态"
                          },
                          model: {
                            value: _vm.childData.houseStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "houseStatus", $$v)
                            },
                            expression: "childData.houseStatus"
                          }
                        },
                        _vm._l(_vm.stateOption, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              label: item.dicName,
                              value: parseInt(item.dicValue)
                            },
                            on: { change: _vm.changeStateValue }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.initialAcceptanceDate") } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form-item-width",
                        attrs: {
                          clearable: "",
                          type: "date",
                          placeholder: "请选择初次验收日期",
                          format: "yyyy 年 MM 月 dd 日",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { change: _vm.handleInitialAcceptanceDate },
                        model: {
                          value: _vm.childData.initialAcceptanceDate,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.childData,
                              "initialAcceptanceDate",
                              $$v
                            )
                          },
                          expression: "childData.initialAcceptanceDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.secondAcceptanceDate") } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form-item-width",
                        attrs: {
                          clearable: "",
                          type: "date",
                          placeholder: "选择日期",
                          format: "yyyy 年 MM 月 dd 日",
                          "value-format": "yyyy-MM-dd"
                        },
                        on: { change: _vm.handleSecondAcceptanceDate },
                        model: {
                          value: _vm.childData.secondAcceptanceDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "secondAcceptanceDate", $$v)
                          },
                          expression: "childData.secondAcceptanceDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "房间数量", prop: "roomNum" } },
                    [
                      _c("el-input-number", {
                        staticClass: "form-item-width",
                        attrs: { clearable: "", min: 1, max: 99 },
                        model: {
                          value: _vm.childData.roomNum,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "roomNum", $$v)
                          },
                          expression: "childData.roomNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.houseIsRentable") } },
                    [
                      _c("el-checkbox", {
                        on: { change: _vm.handleRent },
                        model: {
                          value: _vm.isChecked,
                          callback: function($$v) {
                            _vm.isChecked = $$v
                          },
                          expression: "isChecked"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remark") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "720px" },
                        attrs: {
                          clearable: "",
                          maxlength: "100",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 4 }
                        },
                        model: {
                          value: _vm.childData.houseRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "houseRemark", $$v)
                          },
                          expression: "childData.houseRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }